(function(){
'use strict';

function isMobile(){
  return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
}

function hideSoldOutCards(root){
  var scope=root&&root.querySelectorAll?root:document;
  scope.querySelectorAll('.product-item, .grid__item.product-item').forEach(function(card){
    var soldOut=!!card.querySelector('.js-btn-sold-out, [data-js-product-button-sold-out], .sold-out, .sold_out');
    if(soldOut){
      card.style.setProperty('display','none','important');
      card.setAttribute('aria-hidden','true');
      card.setAttribute('data-erectus-soldout-hidden','true');
    }
  });
}

function addStyles(){
  if(!isMobile() || document.getElementById('erectus-card-frame-styles')) return;
  var style=document.createElement('style');
  style.id='erectus-card-frame-styles';
  style.textContent=[
    '@media (max-width:767px){',
    '.product-item .product-collection__image{width:100%!important;}',
    '.product-item .product-collection__image>a.image_product,.product-item .product-collection__image>a[data-js-product-image]{position:relative!important;display:block!important;width:100%!important;aspect-ratio:1/1!important;overflow:hidden!important;background:#f5f5f5!important;}',
    '.product-item .product-collection__image>a.image_product .pr_lazy_img,.product-item .product-collection__image>a[data-js-product-image] .pr_lazy_img{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;padding-top:0!important;background-size:contain!important;background-position:center center!important;background-repeat:no-repeat!important;background-color:#f5f5f5!important;}',
    '.product-item .product-collection__image>a.image_product .laber_img_1,.product-item .product-collection__image>a.image_product .laber_img_2{background-size:contain!important;background-position:center center!important;background-repeat:no-repeat!important;background-color:#f5f5f5!important;}',
    '.product-item .erectus-mobile-secondary-action{display:none!important;}',
    '.product-item .erectus-mobile-cta-stack{margin:7px 0 9px!important;}',
    '.product-item .erectus-mobile-buy-link{min-height:42px!important;padding:8px 7px!important;background:#f8dada!important;color:#c80000!important;border:1px solid #efc2c2!important;border-radius:8px!important;box-shadow:none!important;font-size:13.5px!important;font-weight:700!important;line-height:1.2!important;}',
    '.product-item .erectus-mobile-buy-link:hover,.product-item .erectus-mobile-buy-link:focus{background:#f4cccc!important;color:#b70000!important;text-decoration:none!important;}',
    '}',
  ].join('');
  document.head.appendChild(style);
}

function patchVariantIds(root){
  var scope=root&&root.querySelectorAll?root:document;
  scope.querySelectorAll('.js_add_to_cart_button[data-pid]').forEach(function(button){
    var pid=(button.getAttribute('data-pid')||'').trim();
    if(pid && /^\d+$/.test(pid)) button.setAttribute('data-variant-id',pid);
  });
}

function normalizePrimaryLabels(root){
  var scope=root&&root.querySelectorAll?root:document;
  scope.querySelectorAll('.erectus-mobile-buy-link').forEach(function(link){
    link.textContent='Comprar';
    link.setAttribute('aria-label','Ver producto para comprar');
  });
}

function run(root){
  hideSoldOutCards(root||document);
  if(!isMobile()) return;
  addStyles();
  patchVariantIds(root||document);
  normalizePrimaryLabels(root||document);
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',function(){run(document);});
}else{
  run(document);
}

document.addEventListener('shopify:section:load',function(event){run(event.target||document);});
document.addEventListener('collection:updated',function(){run(document);});

var queued=false;
var observer=new MutationObserver(function(mutations){
  if(queued) return;
  var relevant=mutations.some(function(m){return m.addedNodes&&m.addedNodes.length;});
  if(!relevant) return;
  queued=true;
  window.requestAnimationFrame(function(){queued=false;run(document);});
});
observer.observe(document.documentElement,{childList:true,subtree:true});
})();
